import { render } from "./CustomerPanelHeader.vue?vue&type=template&id=e41e2658&scoped=true"
import script from "./CustomerPanelHeader.vue?vue&type=script&lang=js"
export * from "./CustomerPanelHeader.vue?vue&type=script&lang=js"

import "./CustomerPanelHeader.vue?vue&type=style&index=0&id=e41e2658&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e41e2658"]])

export default __exports__